import React from "react";
import { PromptMessageCard } from "./PromptMessageCard";
import styles from "./PromptSection.module.css";

export interface PromptMessage {
    role: string;
    content: string;
}

interface Props {
    messages: PromptMessage[];
}

export const PromptSection: React.FC<Props> = ({ messages }) => {
    return (
        <div className={styles.container}>
            {messages.map((message, index) => (
                <PromptMessageCard key={index} message={message} />
            ))}
        </div>
    );
};
